export const BETA_FEATURE_ROUTE_NAMES = {
  LIST: 'betaFeatures',
}
